import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const headList = [
  {
    headTitle: "職員氏名",
  },
  {
    headTitle: "生年月日",
  },
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "退職日",
  },
  {
    top: {
      headTitle: "退職届／他法人への継続異動届",
    },
    bottom: [
      {
        headTitle: "処理状況",
      },
      {
        headTitle: "書類の送付",
      },
      {
        headTitle: "源泉徴収票",
      },
    ],
  },
  {
    headTitle: "退職手当金請求/合算制度利用申出",
  },
  {
    headTitle: "退職手当金額",
  },
  {
    headTitle: "源泉徴収額",
  },
];

const searchFormSchema = {
  facilityName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 20,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
  name: {
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

const searchFormList: any = [
  {
    label: "施設名",
    keyword: "facilityName",
    type: "label",
    inputProps: {
      maxLength: 20,
    },
  },
  {
    label: "職員名",
    keyword: "staffNameKanji",
    type: "label",
    inputProps: {
      maxLength: 48,
    },
  },
];

export { headList, searchFormSchema, searchFormList };
